export const fetchParts = (roleId, search = '') =>
    fetch(`${process.env.REACT_APP_API_URL}/api/app/search/parts`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            roleId,
            search,
            limit: 1000
        })
    })
        .then(resp => resp.json())
        .then(resp => resp.results)
        .catch(console.error);
